<script>
  import { _ } from "svelte-i18n"
  import { fade } from 'svelte/transition'
	import { cubicOut } from 'svelte/easing'
  import { text_entered, text_entered_once, hero_expanded } from './../stores.js'

  $: txt_length = $text_entered.length

</script>

{#if $hero_expanded}
  <div out:fade="{{ duration: 500, easing: cubicOut }}">
    {#if txt_length === 0}
      <p transition:fade="{{ duration: 500, easing: cubicOut }}">
        {$_('textArea.help1')}
      </p>
    {/if}

    {#if txt_length >= 1 && txt_length <= 5}
      <p transition:fade="{{ duration: 500, easing: cubicOut }}">
        {$_('textArea.placeholder')}
      </p>
    {/if}

    {#if (txt_length >= 6 && txt_length <= 9) || txt_length >= 13}
      <p transition:fade="{{ duration: 500, easing: cubicOut }}">
        {#if !$text_entered_once}
          {@html $_('textArea.help2')}
        {:else}
          {@html $_('textArea.help2Alt')}
        {/if}
      </p>
    {/if}
    {#if txt_length >= 10 && txt_length <= 12}
      <p transition:fade="{{ duration: 500, easing: cubicOut }}">
        {@html $_('textArea.help3')}
      </p>
    {/if}
  </div>
{/if}

<style>
  div p {
    position: absolute;
    margin-top: 1rem;
    margin-left: 0.2rem;
		font-family: var(--PensumSans-Bold);
    font-size: 2.4rem;
    color: var(--c-text-on-fill);
  }
  div p :global(b) {
    color: var(--c-accent-teal);
  }
  .dark_theme div p :global(b) {
    color: var(--c-accent);
  }
  
</style>